import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import { useChangeLocaleMutation } from '@/mutations';

import { LOCALES_LIST } from '@/constants';

export const LocaleSwitcher = (props: { url: string }) => {
  const { url } = props;
  const { i18n } = useTranslation();
  const currentLocale = i18n.language;
  const { mutate: changeLocale, isPending } = useChangeLocaleMutation();

  const onLocaleChange = (locale: string) => {
    if (locale === currentLocale) {
      return;
    }

    changeLocale(
      { url, locale },
      {
        onSuccess: () => {
          i18next.changeLanguage(locale);
        },
      },
    );
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        asChild
        className="focus-visible:outline-none"
      >
        <Button
          variant="outline"
          size="sm"
          disabled={isPending}
          className="bg-main-menu-background hover:bg-main-menu-background/80 text-main-menu-foreground border-border border text-sm uppercase focus:ring-0 focus:ring-offset-0 sm:text-base"
        >
          {currentLocale || ''}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="center"
        collisionPadding={8}
        className="dark bg-main-menu-background text-main-menu-foreground"
      >
        {LOCALES_LIST.map((locale) => (
          <DropdownMenuItem
            key={locale}
            className="cursor-pointer uppercase"
            onClick={() => {
              onLocaleChange(locale);
            }}
          >
            {locale}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
